import { observable, runInAction } from 'mobx';
import { DetailModel, IRemindServices, RemindModel, RemindUpdateModel, WarrantyTimeRemindModel } from 'services/Masterdata/warrantyRemind_services';
import { DataResponse } from 'services/response';


export type warrantyRemindStore = {
  warrantyRemindRespone: DataResponse<RemindModel[]>
  createRemindRespone: DataResponse<null>
  detailRemindRespone: DataResponse<DetailModel | undefined>
  dataUpdateRemind: DataResponse<RemindUpdateModel[]>

  caculate: DataResponse<null>

  warrantyTimeRemind: DataResponse<WarrantyTimeRemindModel[]>
};

export interface IWarrantyRemindPresenter {
  createStore(): warrantyRemindStore;
  //  data warranty remind
  getDataListWarrantyRemind(store: warrantyRemindStore, data: object): Promise<void>

  createWarrantyRemind(store: warrantyRemindStore, data: object): Promise<void>
  editWarrantyRemind(store: warrantyRemindStore, data: object): Promise<void>
  detailWarrantyRemind(store: warrantyRemindStore, remindConfigId: string): Promise<void>
  // cập nhật lịch nhắc cho phiếu ĐKBH đã tạo
  reminderUpdateCalendar(store: warrantyRemindStore, data: object): Promise<void>
  // xử lý cập nhật lịch nhắc nhở
  caculateCalendar(store: warrantyRemindStore, data: object): Promise<void>



  // Nhắc nhở lịch bảo hành
  warrantyTimeRemind(store: warrantyRemindStore, data: object): Promise<void>

}

export function createWarrantyRemindPresenter({ warrantyRemindServices }: { warrantyRemindServices: IRemindServices }): IWarrantyRemindPresenter {
  return {
    createStore: (): warrantyRemindStore =>
      observable({
        warrantyRemindRespone: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          }
        },
        detailRemindRespone: {
          data: undefined,
          message: '',
          isSuccess: false,
        },
        createRemindRespone: {
          data: null,
          message: '',
          isSuccess: false,
        },
        dataUpdateRemind: {
          data: [],
          message: '',
          isSuccess: false,
        },
        caculate: {
          data: null,
          message: '',
          isSuccess: false,
        },
        warrantyTimeRemind: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            pageIndex: 0,
            pageSize: 0,
            totalPages: 0
          }
        },
      }),
    getDataListWarrantyRemind: async (store: warrantyRemindStore, data) => {
      try {
        const result = await warrantyRemindServices.getDataListWarrantyRemind(data);
        runInAction(() => {
          store.warrantyRemindRespone.data = result.data;
          store.warrantyRemindRespone.isSuccess = result.isSuccess;
          store.warrantyRemindRespone.message = result.message;
          store.warrantyRemindRespone.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // create
    createWarrantyRemind: async (store: warrantyRemindStore, data) => {
      try {
        const result = await warrantyRemindServices.createWarrantyRemind(data);
        runInAction(() => {
          store.createRemindRespone.isSuccess = result.isSuccess;
          store.createRemindRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // edit
    editWarrantyRemind: async (store: warrantyRemindStore, data) => {
      try {
        const result = await warrantyRemindServices.editWarrantyRemind(data);
        runInAction(() => {
          store.createRemindRespone.isSuccess = result.isSuccess;
          store.createRemindRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // detail
    detailWarrantyRemind: async (store: warrantyRemindStore, id) => {
      try {
        const result = await warrantyRemindServices.detailWarrantyRemind(id);
        runInAction(() => {
          store.detailRemindRespone.data = result.data;
          store.detailRemindRespone.isSuccess = result.isSuccess;
          store.detailRemindRespone.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // cập nhật lịch nhắc cho phiếu ĐKBH đã tạo
    reminderUpdateCalendar: async (store: warrantyRemindStore, object) => {
      try {
        const result = await warrantyRemindServices.reminderUpdateCalendar(object);
        runInAction(() => {
          store.dataUpdateRemind.data = result.data;
          store.dataUpdateRemind.isSuccess = result.isSuccess;
          store.dataUpdateRemind.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },


    // create
    caculateCalendar: async (store: warrantyRemindStore, data) => {
      try {
        const result = await warrantyRemindServices.caculateCalendar(data);
        runInAction(() => {
          store.caculate.isSuccess = result.isSuccess;
          store.caculate.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },

    // Nhắc nhở lịch bảo hành
    warrantyTimeRemind: async (store: warrantyRemindStore, data) => {
      try {
        const result = await warrantyRemindServices.warrantyTimeRemind(data);
        runInAction(() => {
          store.warrantyTimeRemind.data = result.data;
          store.warrantyTimeRemind.isSuccess = result.isSuccess;
          store.warrantyTimeRemind.message = result.message;
          store.warrantyTimeRemind.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },
  };
}
